import * as angular from 'angular';

import { TicketStatus } from '../../models';

export interface ITicketStatusService {
    getAll(force?: boolean): angular.IPromise<TicketStatus[]>;
}

export class TicketStatusService implements ITicketStatusService {
    static serviceId = 'ticketStatusService';

    private _collection: TicketStatus[] = [
        { id: 1, name: 'New', order: 0, isVisible: true },
        { id: 2, name: 'Assigned', order: 1, isVisible: true },
        { id: 3, name: 'Completed', order: 2, isVisible: true },
        { id: 4, name: 'Closed', order: 3, isVisible: false },
        { id: 5, name: 'Rejected', order: 4, isVisible: true },
    ];

    static $inject = ['$q'];
    constructor(private _$q: angular.IQService) {
    }

    getAll(force?: boolean): angular.IPromise<TicketStatus[]> {
        return this._$q.when(this._collection.sort((a, b) => a.order < b.order ? -1 : 1));
    }
}